import React from "react";
import { createRoot } from "react-dom/client";
import GlansgruppenApp from "./App.jsx";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <GlansgruppenApp />
  </React.StrictMode>
);
